<!--<div id="wrapper">-->
<!--  <div id="content">-->
<div class="about-page">
  <header class="about-header">
    <p class="eyebrow">About</p>
    <h1>A few words about me</h1>
  </header>

  <article class="about-content">
    <p>
      I am an experienced Android Developer with <b>many personal projects finished</b>. Strictly for Android I finished
      in total more than <b>10</b> apps,
      from which 5 are published on <b>Google Play</b>. To develop them, I utilized <b>Kotlin</b> and <b>Java</b>.
      I am familiar with many libraries and in my apps I have followed good practices like <b>DRY</b> and <b>KISS</b>
      for a long time. I also possess experience with <b>MVVM</b> and <b>MVP</b>.
    </p>

    <p>
      I finished also applications of another tech stack and technologies.
    </p>

    <p>
      In 2014 I graduated from university with an <b>engineer's degree</b>. During that stage of my education,
      I studied Information and Communications Technology at the University of Science and Technology in Bydgoszcz.
      Next, I earned my <b>master's degree</b> majoring in Electronics and Telecommunications from the same university.
    </p>

    <p>During my free time I like to learn foreign languages. I am a big enthusiast of learning with words association.
      I built two products that addresses this concept:
      <br>
      • <a href="https://play.google.com/store/apps/details?id=pl.jawegiel.assocwords&hl=en" target="_blank">app</a>
      <br>
      • <a href="https://assocwords-webapp.onrender.com/" target="_blank">website</a>
    </p>

    <p>Do you like my content? Would you like to consider supporting me with a small amount? If you do, you will receive app updates even more frequent and I will be really grateful ☺️. You can buy me a coffee <a href="https://buycoffee.to/jawegiel" target="_blank">here</a>.</p>


    <p class="timeline-note">
      This website exists as of: <b>04.01.2021</b>.
    </p>
  </article>

  <div class="flag-counter">
    <a href="https://info.flagcounter.com/EbQI" target="_blank" rel="noopener noreferrer">
      <img
        src="https://s01.flagcounter.com/count/EbQI/bg_FFFFFF/txt_000000/border_CCCCCC/columns_2/maxflags_10/viewers_0/labels_0/pageviews_0/flags_0/percent_0/"
        alt="Flag Counter"
        width="150"
        height="59">
    </a>
  </div>
</div>
<!--  </div>-->
<!--</div>-->
